import { InputAdornment, TextField } from '@mui/material';
import { StandardTextFieldProps } from '@mui/material/TextField';
import MuiDanger from 'components/MuiExtras/Typography/MuiDanger';
import MuiSuccess from 'components/MuiExtras/Typography/MuiSuccess';
import * as React from 'react';

interface IState {
}

interface IProps {
    inputType: "text" | "password";
    valueToCompare: string;
    maxLength?: number;
    onChange?: (v: string) => void;
}

type Props = IProps & Omit<StandardTextFieldProps, "onChange" | "InputProps">;

class MuiCompareTextField extends React.PureComponent<Props, IState> {

    private refText: any;

      static defaultProps: Partial<Props> = {
        inputType: "password",
        margin: "normal"
    };

    private changeValue = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const text = e.target.value;
        if (this.props.onChange) this.props.onChange(text);
    }


    public get isValid() {
        return this.refText && this.refText.value.length > 0 && this.refText.value == this.props.valueToCompare;
    }

    render() {

        const { inputProps, inputType, valueToCompare, ...rest } = this.props;
        const icon = !this.refText || this.refText.value.length == 0
            ? null
            : this.isValid
                ? <MuiSuccess showIcon />
                : <MuiDanger showIcon />

        return (
            <TextField
                {...rest}
                InputProps={
                    {
                        type: inputType,
                        endAdornment: icon
                            ? <InputAdornment position='end'>{icon}</InputAdornment >
                            : null
                    }
                }
                inputProps={
                    {
                        ...inputProps, 
                        ...{ maxLength: this.props.maxLength }
                    }
                }
                inputRef={(ref) => this.refText = ref}
                onChange={this.changeValue}
                value={this.props.value}
            />
        )
    }
}

export default MuiCompareTextField;